// ** Reducers Imports
import navbar from "./navbar";
import refresh from "./refreshSlice";
import updateReducer from "./updateCard";
import layout from "./layout";
import auth from "./authentication";
import pricing from "./pricing";
import todo from "@src/views/apps/todo/store";
import chat from "@src/views/apps/chat/store";
import users from "@src/views/apps/user/store";
import filter from "./filter";
import providerOnboarding from "./providerOnboarding";
import clientOnboarding from "./clientOnboarding";

import invoice from "@src/views/apps/invoice/store";
import calendar from "@src/views/apps/calendar/store";
import ecommerce from "@src/views/apps/ecommerce/store";
import dataTables from "@src/views/tables/data-tables/store";
import permissions from "@src/views/apps/roles-permissions/store";
import tickets from "./tickets";
import status from "./status";
import videoTutorialReducer from "./videoTutorial";

const rootReducer = {
  auth,
  pricing,
  todo,
  chat,
  users,
  navbar,
  layout,
  filter,
  invoice,
  calendar,
  ecommerce,
  dataTables,
  permissions,
  tickets,
  refresh,
  providerOnboarding,
  clientOnboarding,
  update: updateReducer,
  status,
  videoTutorial: videoTutorialReducer,
};

export default rootReducer;
